import apiClient from '@/services/axios'
import store from 'store'

/**
 * TODAS AS FUNÇÕES ESTÃO PROTEGIDAS CONTRA SQL INJECTION
 */

//const url = process.env.NODE_ENV === "production" ? '/intranet' : "https://intranetcmpdev.cm-pombal.pt"
//const url = process.env.NODE_ENV === "production" ? '/intranet/webservice/fornecidos' : "https://intranetcmpdev.cm-pombal.pt"
//const url = process.env.NODE_ENV === "production" ? '/intranet' : '/intranet/webservice/fornecidos'
//const url = process.env.NODE_ENV === "production" ? '/intranet' : '/intranet'
const url = process.env.NODE_ENV === "production" ? '/intranet/webservice/fornecidos' : "https://intranetcmpdev.cm-pombal.pt/webservice/fornecidos"


/**
 * Para realizar a autenticação
 * @param {*} username 
 * @param {*} password 
 * @returns 
 */
/*
export async function login(username, password) {
    return apiClient
        .post(url + '/intranet_utilizadores/autenticacaoLogin', {
            username,
            password,
        })
        .then(response => {
            if (response) {
                const token = response.data.output.token

                if (token) {
                    store.set('accessToken', token)
                }
                return response.data.output
            }
            return false
        })
        .catch(err => console.log(err))
}
*/

/**
 * MFA - 1ª fase - autenticação
 * @param {*} username 
 * @param {*} telemovel 
 * @param {*} userIp : ip publico do cliente 
 */
export async function ws_autenticacao_mfa_1(username, telemovel, user_ip) {
    return apiClient
        .post(url + '/intranet_utilizadores/autenticacaoMFA1', {
            username,
            telemovel,
            user_ip,
        }, {
            headers: {
                'App-Token': GlobalConfig.intranetAppToken,
            },
        })
        .then(response => {
            if (response) {
                return response.data
            }
            return false
        })
        .catch(err => console.log(err))
}


/**
 * MFA - 2ª fase - validação
 * @param {*} password 
 * @param {*} codigo 
 */
export async function ws_autenticacao_mfa_2(password, codigo, tokenMFA) {
    return apiClient
        .post(url + '/intranet_utilizadores/autenticacaoMFA2', {
            password,
            codigo,
            tokenMFA,
        }, {
            headers: {
                'App-Token': GlobalConfig.intranetAppToken,
            },
        })
        .then(response => {
            if (response) {
                return response.data
            }
            return false

        })
        .catch(err => console.log(err))
}



/**
 * Para obter dados do user logado
 * Portal do colaborador
 * @returns 
 */
export async function ws_currentAccount() {
    let token = store.get('accessToken')
    //console.log(token)
    if (typeof token === 'undefined')
        return false

    const params = new URLSearchParams([['token', token]]);
    return apiClient
        //.get(url + '/webservice/fornecidos/intranet_utilizadores/autenticacaoGetAccount', { params })
        .get(url + '/intranet_utilizadores/autenticacaoGetAccount', {
            headers: {
                'App-Token': GlobalConfig.intranetAppToken,
            },
            params,
        })
        .then(response => {
            if (response) {
                return response.data
            }
            return false
        })
        .catch(err => console.log(err))
}


/**
 * Para realizar o logout da sessão
 * @returns 
 */
export async function ws_logout() {
    store.remove('accessToken')
    return apiClient
        .get('/auth/logout', {
            headers: {
                'App-Token': GlobalConfig.intranetAppToken,
            },
        })
        .then(() => {
            store.remove('accessToken')
            return true
        })
        .catch(err => console.log(err))
}


/**
 * Obter lista de de todos os funcionários que estão a baixo de uma chefia;
 * arvore de funcionarios abaixo de uma chefia. Os da sua unidade e os das unidades dependentes
 * @param nif : <string> nif do funionário chefe
 */
export async function ws_uniOrgGetListaFuncionariosAbaixoChefia(nif) {
    let token = store.get('accessToken')

    if (typeof token === 'undefined')
        return false

    const params = new URLSearchParams([['nif', nif]]);
    return apiClient
        .get(url + '/intranet_grupos/uniOrgGetListaFuncionariosAbaixoChefiaT', {
            headers: {
                'App-Token': GlobalConfig.intranetAppToken,
            },
            params,
        })
        .then(response => {
            if (response) {
                return response.data
            }
            return false
        })
        .catch(err => console.log(err))
}


/**
 * Com base nos dados de um funcionário, valida se é responsavel da unidade organica. Se for responsavel, devolve a unidade organica e todas as dependencias
 * @param nif : <string> nif do funionário chefe
 */
export async function ws_uniOrgGetUniOrgPorChefia(nif) {
    let token = store.get('accessToken')

    if (typeof token === 'undefined')
        return false
    const params = new URLSearchParams([['nif', nif]]);
    return apiClient
        .get(url + '/intranet_grupos/uniOrgGetUniOrgPorChefiaT', {
            headers: {
                'App-Token': GlobalConfig.intranetAppToken,
            },
            params,
        })
        .then(response => {
            if (response) {
                return response.data
            }
            return false
        })
        .catch(err => console.log(err))
}


/**
 * Obtem todos as uni orgs abaixo de determinada uni org ou todas
 * @param codigo : <string> nif do funionário chefe
 */
export async function ws_uniOrgGetUniOrgGetAll(codigo) {
    let token = store.get('accessToken')

    if (typeof token === 'undefined')
        return false
    const params = new URLSearchParams([['codigo', codigo]]);
    return apiClient
        .get(url + '/intranet_grupos/uniOrgGetUnidadesOrganicasT', {
            headers: {
                'App-Token': GlobalConfig.intranetAppToken,
            },
            params,
        })
        .then(response => {
            if (response) {
                return response.data
            }
            return false
        })
        .catch(err => console.log(err))
}


/**
 * para obter uma lista de funcionários com base num opu vários códigos das unidades organicas
 * @param codigo : <string> codigo do registo a pesquisar Cod. SAGA
 */
export async function ws_uniOrgGetFuncionariosByUniOrgCodigos(codigos) {
    let token = store.get('accessToken')

    if (typeof token === 'undefined')
        return false
    const params = new URLSearchParams([['codigos', codigos]]);
    return apiClient
        .get(url + '/intranet_grupos/uniOrgGetFuncionariosByUniOrgCodigosT', {
            headers: {
                'App-Token': GlobalConfig.intranetAppToken,
            },
            params,
        })
        .then(response => {
            if (response) {
                return response.data
            }
            return false
        })
        .catch(err => console.log(err))
}


/**
 * get pelouros
 */
export async function ws_getPelourosDaUniOrg(codigo, tipoCodigo, tipoResponsavel) {
    let token = store.get('accessToken')

    if (typeof token === 'undefined')
        return false
    const params = new URLSearchParams([['codigo', codigo], ['tipo_codigo', tipoCodigo], ['tipo_responsavel', tipoResponsavel]]);
    return apiClient
        .get(url + '/intranet_grupos/uniOrgGetPelourosT', {
            headers: {
                'App-Token': GlobalConfig.intranetAppToken,
            },
            params,
        })
        .then(response => {
            if (response) {
                return response.data
            }
            return false
        })
        .catch(err => console.log(err))
}